// Recovered compiled webpack factory 6997. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "addLocale", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(73879),
    a = r(2018);
  function o(e, t, r, o) {
    if (!t || t === r) return e;
    let i = e.toLowerCase();
    return !o && ((0, a.pathHasPrefix)(i, "/api") || (0, a.pathHasPrefix)(i, "/" + t.toLowerCase()))
      ? e
      : (0, n.addPathPrefix)(e, "/" + t);
  }
}
